"use client";

import Image from "next/image";
import { Users, Compass, Heart, Star } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Title, Text } from "@/components/ui/Headings";

const TrustCredibilitySection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <section className="py-4 sm:py-4 lg:py-4 bg-gray-50">
      <div className="max-w-6xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 sm:gap-12 lg:gap-10 items-center">
          <div>
            <Title
              size="md"
              className="mb-4 sm:mb-4 lg:mb-4 leading-tight hidden md:block"
            >
              {t("home.trust.heading")}
            </Title>
            <div className="space-y-2 sm:space-y-2">
              <div className="flex items-start space-x-4">
                <Users className="h-6 w-6 sm:h-7 sm:w-7 text-primary-600 mt-1 flex-shrink-0" />
                <div>
                  <Title size="sm" className="font-semibold mb-2">
                    {t("home.trust.localExpertTitle")}
                  </Title>
                  <Text
                    variant="body"
                    className="text-gray-600 leading-relaxed"
                  >
                    {t("home.trust.localExpertText")}
                  </Text>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <Heart className="h-6 w-6 sm:h-7 sm:w-7 text-primary-600 mt-1 flex-shrink-0" />
                <div>
                  <Title size="sm" className="font-semibold mb-2">
                    {t("home.trust.communityTitle")}
                  </Title>
                  <Text
                    variant="body"
                    className="text-gray-600 leading-relaxed"
                  >
                    {t("home.trust.communityText")}
                  </Text>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <Compass className="h-6 w-6 sm:h-7 sm:w-7 text-primary-600 mt-1 flex-shrink-0" />
                <div>
                  <Title size="sm" className="font-semibold mb-2">
                    {t("home.trust.sustainableTitle")}
                  </Title>
                  <Text
                    variant="body"
                    className="text-gray-600 leading-relaxed"
                  >
                    {t("home.trust.sustainableText")}
                  </Text>
                </div>
              </div>
            </div>
          </div>
          <div className="relative h-32 sm:h-64 lg:h-80 mt-2 lg:mt-0">
            <Image
              src="https://images.pexels.com/photos/3278215/pexels-photo-3278215.jpeg?auto=compress&cs=tinysrgb&w=800&h=600&fit=crop"
              alt={t("home.trust.localExpertTitle") as string}
              fill
              className="rounded-2xl shadow-2xl object-cover"
            />
            <div className="absolute -bottom-2 -left-2 sm:-bottom-4 sm:-left-4 bg-white p-2.5 sm:p-4 rounded-lg shadow-xl max-w-[170px] sm:max-w-[260px]">
              <div className="flex items-center space-x-[2px] sm:space-x-1.5 mb-1">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className="h-2 w-2 sm:h-3 sm:w-3 fill-yellow-400 text-yellow-400"
                  />
                ))}
              </div>
              <Text
                variant="tinycaption"
                className="text-gray-600 leading-tight"
              >
                {t("home.trust.quote")}
              </Text>
              <Text variant="tinycaption" className="text-gray-500 mt-0.5">
                {t("home.trust.quoteAttribution")}
              </Text>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustCredibilitySection;
